exports = module.exports = require("../../../node_modules/_css-loader@1.0.0@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** border */\n/** border */\n/** table */\n/** tree */\n/* Popover\r\n-------------------------- */\n/* Dialog\r\n-------------------------- */\n.aside-container[data-v-202481af] {\n  position: relative;\n  background-color: #2d3037;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-right: solid 1px #e6e6e6;\n}\n.nav-container[data-v-202481af] {\n  padding: 0;\n  -webkit-box-shadow: 0px 1px 2px #dbdbdb;\n          box-shadow: 0px 1px 2px #dbdbdb;\n  z-index: 100;\n  min-width: 1200px;\n}\n", ""]);

// exports
